var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomePageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.247,
    height: 20.25,
    viewBox: "0 0 20.247 20.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "home_1_",
    "data-name": "home (1)",
    d: "M19.7,8.808h0L11.441.546a1.864,1.864,0,0,0-2.636,0L.549,8.8.541,8.81a1.863,1.863,0,0,0,1.241,3.176l.057,0h.329v6.079A2.184,2.184,0,0,0,4.35,20.25H7.582a.593.593,0,0,0,.593-.593V14.891a1,1,0,0,1,1-1h1.906a1,1,0,0,1,1,1v4.766a.593.593,0,0,0,.593.593H15.9a2.184,2.184,0,0,0,2.182-2.182V11.989h.305A1.864,1.864,0,0,0,19.7,8.808Zm0,0",
    transform: "translate(0.001)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageIcon);
export default __webpack_public_path__ + "static/media/homePageIcon.99bf9757f7a49a133799b468588e4aca.svg";
export { ForwardRef as ReactComponent };